import styled from 'styled-components';

const CheckoutPageWrapper = styled.div`
  & > div.container {
    margin: 0 auto;
    max-width: 1024px;
    display: flex;
    align-items: flex-start;

    & > div.main {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: stretch;
    }

    & > div.gutter {
      flex: 0 0 20px;
    }

    & > div.side {
      flex: 0 0 300px;
      display: flex;
      flex-direction: column;

      ${(props) =>
        props.stickyTop !== null &&
        `position: sticky; top: ${props.stickyTop}px;`}

      & > h2 {
        text-align: center;
      }
    }

    @media (max-width: 800px) {
      flex-direction: column;

      & > div.main {
        width: 100%;
      }

      & > div.side {
        width: 100%;
        flex: 0 0;
      }
    }
  }
`;

export default CheckoutPageWrapper;
